/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_LensInputs */

const en_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lens`)
};

const ar_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العدسة`)
};

const bn_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লেন্স`)
};

const de_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objektiv`)
};

const es_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo`)
};

const fr_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif`)
};

const pt_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lente`)
};

const zh_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头`)
};

const tr_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lens`)
};

const ru_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объектив`)
};

const pl_image_inspector_lens = /** @type {(inputs: Image_Inspector_LensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiektyw`)
};

/**
* | output |
* | --- |
* | "Lens" |
*
* @param {Image_Inspector_LensInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_lens = /** @type {((inputs?: Image_Inspector_LensInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_LensInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_lens(inputs)
	if (locale === "bn") return bn_image_inspector_lens(inputs)
	if (locale === "de") return de_image_inspector_lens(inputs)
	if (locale === "es") return es_image_inspector_lens(inputs)
	if (locale === "fr") return fr_image_inspector_lens(inputs)
	if (locale === "pt") return pt_image_inspector_lens(inputs)
	if (locale === "zh") return zh_image_inspector_lens(inputs)
	if (locale === "tr") return tr_image_inspector_lens(inputs)
	if (locale === "ru") return ru_image_inspector_lens(inputs)
	if (locale === "pl") return pl_image_inspector_lens(inputs)
	return en_image_inspector_lens(inputs)
});